import lang from '../../lib/language';

export const WATCH_LIST_TABLE_HEADERS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonChart(),
  lang.commonLastPriceShort(),
  lang.commonChange(),
  lang.commonPercentChange(),
];

export const WATCH_LIST_TABLE_ITEMS = [
  'date',
  'priceRange',
  'industry',
  'time',
  'status',
  'ratio',
  'eventType',
  'ordType',
  'orderQty',
  'price',
  'orderValue',
  'purchasePrice',
  'investments',
  'marketValue',
  'valueShare',
  'type',
  'marketPrice',
  'unrealizedProfit',
  'createdAt',
  'updatedAt',
  'buttons',
  'quantity',
  'type',
  'setPrice',
  'expiryDate',
  'datePlaced',
];
export const TABLE_HEADERS_EARNINGS_CALENDARS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonDate(),
  lang.headerEarningsCalendarEarningsCallTime(),
  lang.headerEarningsCalendarEarningsPrevEPS(),
  lang.headerEarningsCalendarEarningsEPSEstimate(),
];
export const TABLE_HEADERS_MY_ACCOUNT_MY_STOCKS = [
  lang.commonSymbol(),
  lang.headerMyAccountMyStockQuantity(),
  lang.headerMyAccountMyStockPurchasePrice(),
  lang.headerMyAccountMyStockMarketPrice(),
  lang.headerMyAccountMyStockUnrealizedProfit(),
  lang.headerMyAccountMyStockButtons(),
];

export const TABLE_HEADERS_SYMBOL_DETAILS_PENDING_ORDERS = [
  lang.headerMyAccountPendingOrderDatePlaced(),
  lang.headerMyAccountPendingOrderType(),
  lang.headerMyAccountPendingOrderQuantity(),
  lang.headerMyAccountPendingOrderSetPrice(),
  lang.headerMyAccountPendingOrderExpiryDate(),
  lang.headerMyAccountPendingOrderButtons(),
];

export const WATCH_LIST_TABLE_HEADERS_MY_ACCOUNT_PENDING_ORDERS = [
  lang.headerMyAccountPendingOrderSymbolName(),
  ...TABLE_HEADERS_SYMBOL_DETAILS_PENDING_ORDERS,
];
